import { Button } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { useLocation } from 'wouter';
import { useTranslation } from '../../hooks/useTranslation';

// Botón "Volver" de las páginas de detalle o creación. Va arriba a la
// izquierda, antes del Header. Ver design.md › Navegación.
const BackButton = ({ href, label }: { href: string; label?: string }) => {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();

  return (
    <Button
      variant='light'
      size='sm'
      className='mb-4 w-fit'
      startContent={<Icon icon='tabler:arrow-left' />}
      onPress={() => setLocation(href)}
    >
      {label ?? t('Volver')}
    </Button>
  );
};

export default BackButton;
